import axios from "axios";
import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";

const SeachForCompare = () => {
  const [searchValue, setSearchValue] = useState("");

  const searchCompare = async () => {
    if (searchValue === "") return;

    const url = `https://api.rainforestapi.com/request?api_key=EE5717A6651049349E35F5C34EE9D998&type=search&amazon_domain=amazon.com&search_term=${searchValue}`;

    const { data } = await axios.get(url);
    console.log(data);
  };

  return (
    <div>

      <div class="flex items-center">
        <label for="voice-search" class="sr-only">
          Search
        </label>
        <div class="relative w-full">
          <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
            <svg
              class="w-5 h-5 text-gray-500 "
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <input
            type="text"
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            id="voice-search"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:border-rose-400 outline-none shadow-md focus:shadow-rose-200  block w-full pl-10 p-2.5  "
            placeholder="Search for any products ..."
          />
          <button
            onClick={searchCompare}
            class="flex absolute inset-y-0 right-8 items-center pr-3"
          >
            <FiSearch className="hover:text-blue-500" />
          </button>
          <button
            type="button"
            class="flex absolute inset-y-0 right-0 items-center pr-3"
          >
            <svg
              class="w-4 h-4 text-rose-500  hover:text-gray-900 "
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
      </div>


    </div>
  );
};

export default SeachForCompare;
